import { Coords } from 'google-map-react';

// : (".*?")|: null => : string

// : \d+ => : number

// : (false|true) => : boolean

export type TParams = { id?: string; idc?: string; idm?: string };

export type Nstring = null | string;

export interface Authorize {
    access_token: string;
    expires_at: number;
    user: User;
}

export interface ListingMeta {
    total: number;
    pages: number;
}

export interface Listing {
    meta: ListingMeta;
    data:
        | Partial<Driver>[]
        | Partial<Partner>[]
        | Partial<Vehicle>[]
        | Partial<Rider>[]
        | Partial<Company>[]
        | Partial<Reservation>[]
        | Partial<Booking>
        | Partial<BillSimple>[]
        | Partial<BillPeriod>[];
}

export interface Regulation {
    //TODO
}

export interface ExpressPaiementRegulation extends Regulation {
    //TODO
}

export interface RegulationBilling {
    adjustment_type: string;
    author_id: string;
    author?: LightStructure;
    created_at: string;
    credit_note_id: string;
    customer_id: string;
    customer_status: string;
    id: string;
    label: string;
    partner?: LightStructure;
    partner_bill_id: string;
    partner_id: string;
    pre_tax_customer: number;
    pre_tax_partner: number;
    product_type: string;
    ride_id: string;
    updated_at: string;
    with_tax_customer: number;
    with_tax_partner: number;
}

export interface BookingLine {
    id: number;
    amount: number;
    booking: LightBooking;
    rule: Rule;
}

export interface LightBooking {
    id: number;
    creation_date: number;
}

export interface Break {
    id: number;
    start_date: number;
    end_date: number;
    start_reason: string;
    end_reason: string;
    deducted_from_session_time: boolean;
}

export interface Session {
    id: number;
    start_date: number;
    end_date: number;
}

export interface SessionLine {
    id: number;
    amount: null | number;
    start_date: number;
    end_date: number;
    session: Session;
    breaks: Break[];
    rule: Rule;
}

export interface OBPLine {}

export interface BillLine {
    id: number;
    amount: number;
    type: string;
    obp: number;
    rule: Rule[];
    regulations: Regulation[];
    driver: Partial<Driver>;
    booking_lines: BookingLine[];
    session_lines: SessionLine[];
    obp_lines: OBPLine[];
}

export interface RideDetails {
    date: string;
    distance: number;
    driver: LightStructure;
    end: Partial<Address>;
    id: string;
    pre_tax_customer: number;
    pre_tax_partner: number;
    ride_number: string;
    start: Partial<Address>;
    surge: number;
    tips: number;
    with_tax_customer: number;
    with_tax_partner: number;
}

export interface DriverTotal {
    distance: number;
    driver: LightStructure;
    pre_tax_customer: number;
    pre_tax_partner: number;
    tips: number;
    with_tax_customer: number;
    with_tax_partner: number;
}

export interface BillDetails {
    week: number;
    year: number;
    rides: {
        totals: {
            tips: number;
            distance: number;
            pre_tax_partner: number;
            pre_tax_customer: number;
            with_tax_partner: number;
            with_tax_customer: number;
        };
        details: RideDetails[];
        totals_by_driver: DriverTotal[];
    };
    amounts: {
        vat: [
            {
                rate: number;
                amount: number;
            },
        ];
        total: {
            activity: number;
            rides_vat: number;
            turnover_pre_tax: number;
        };
        details: {
            tips: number;
            rides: number;
            snappay: number;
            adjustments: number;
            onboard_payment: number;
        };
    };
    partner: Partial<Partner>;
}

export interface BillPartner {
    // id: number;
    // status: BillPartnerStatus;
    // start_date: number;
    // end_date: number;
    // payment_date: null | number;
    // amount: number;
    // amount_with_tip: number;
    // tip: number;
    // obp: number;
    // ep: number;
    // vat_amount: number;
    // vat_rate: null | number;
    // exempt_from_vat: boolean;
    // additional_information: Nstring;
    // amount_with_vat: number;
    // amount_with_vat_with_tip: number;
    // partner_accountacy_creation_date: number;
    // partner_accountancy_bill_number: null | string;
    // partner: Partial<Partner>;
    // regulations: Regulation[];
    // epregulations: ExpressPaiementRegulation[];
    // bill_document_url: string;
    // lines: BillLine[];

    amount_pre_tax: number;
    amount_with_tax: number;
    bill_number: string;
    created_at: string;
    details: BillDetails;
    document_path: string;
    end_date: string;
    id: any;
    issue_date: string;
    partner: LightStructure;
    partner_id: string;
    remaining_balance: number;
    start_date: string;
    status: string;
    updated_at: string;
    regulations_billing?: RegulationBilling[];
}

export enum BillPartnerStatus {
    PENDING = 'pending', // générée et à valider
    BLOCKED = 'blocked', // facture exclue
    VALIDATED = 'validated', // facture validée
    REPORTED = 'reported', // facture reportée (négative)
    SENT = 'sent', // facture payée et envoyée
}

export enum CreditNoteType {
    EXCEPTIONAL = 'exceptional',
    MONTH = 'month',
    RIDE = 'ride',
}
export interface CreditNote {
    id: number;
    creation_date: number;
    public_id: string;
    pdf_invoice_url: string;
    net_price_with_vat: number;
    net_price_without_vat: number;
    reason: Nstring;
    related_bill: BillSimple;
}

export interface BillPeriod {
    id: number;
    public_id: string;
    creation_date: number;
    type: string;
    net_price_with_vat: number;
    net_price_with_vat_with_tip: number;
    unrecoverable: boolean;
    start_date: number;
    end_date: number;
    paid: boolean;
    paid_amount: number;
    pdf_invoice_url: string;
    company: null | Partial<Company>;
    net_price: number;
}

export interface BillSimple {
    id: number;
    public_id: string;
    creation_date: number;
    type: string;
    net_price_with_vat: number;
    net_price_with_vat_with_tip: number;
    tip: number;
    unrecoverable: boolean;
    paid: boolean;
    transaction: TransactionError;
    pdf_invoice_url: string;
    reservation: null | Partial<Reservation>;
    company: null | Partial<Company>;
    booking: null | Partial<Booking>;
    onboard_payment: boolean;
}

export interface Balance {
    t: number;
    v: number;
}

export interface SnappayFigures {
    activated: string;
    ep_withdrawable: string;
    ep_cashedout: string;
    ep_withdrawable_amount: number;
    ep_cashedout_amount: number;
    ep_cashedout_amount_overall: number;
    ep_avg_bounty: number;
    ep_avg_cashedout: number;
}

export interface SnappayConfig {
    account_threshold: number;
}

// TODO
export interface Snappay {
    stats: {
        config: SnappayConfig;
        figures: SnappayFigures;
        accounts: any;
        // {
        //     fc319c94-0cd0-4c9f-8e54-019957a11e3f: {
        //         currency: string,
        //         balance: Balance[]
        //     }
        // },
        cashouts: any[];
    };
    transactions: any[];
}

export interface User {
    id: number;
    uuid?: string;
    email: string;
    type: string;
    firstname: string;
    lastname: string;
    // Viadialog
    agent?: Agent;
    additional_info?: string;
}

export interface UserList {
    company: {
        id: string;
        name: string;
    };
    email: string[];
    firstname: string;
    id: string;
    lastname: string;
    phone: string[];
}

export interface Location {
    id: number;
    lat: number;
    lng: number;
    comments: Nstring;
    address: Address;
}

export interface Order {
    id: number;
    base_price_with_vat: number;
    base_price_without_vat: number;
}

export interface Rejection {
    type: string;
    date: number;
    driver?: Partial<Driver>;
    driver_id?: number;
    booking_id?: number;
}

export interface Line {
    name: string;
    amount_with_vat: number;
    amount_without_vat?: number;
    vat_rate?: number;
}

export interface TransactionError {
    error_description: Nstring;
}
export interface Bill {
    id: number;
    public_id: string;
    type: string;
    vat_rate: number;
    base_price_with_vat: number;
    base_price_without_vat: number;
    net_price_with_vat: number;
    net_price_without_vat: number;
    credit_used_with_vat: number;
    promo_amount_with_vat: number;
    tip: number;
    unrecoverable: boolean;
    paid: boolean;
    transaction: TransactionError;
    net_price_with_vat_with_tip: number;
    net_price_without_vat_with_tip: number;
    vat_amount: number;
    pdf_invoice_url: string;
    credit_notes_total_net_price_without_vat: number;
    credit_notes_total_net_price_with_vat: number;
    partner_bill_booking_line: null; //TODO
    onboard_payment: boolean;
    lines: Line[];
    net_price: number;
}

export interface Booking {
    id: number;
    creation_date: number;
    acceptance_date: null | number;
    driver_arrival_date: null | number;
    pickup_date: null | number;
    status: string;
    bills_total_base_price_with_vat: number;
    bills_total_net_price_without_vat: number;
    bills_total_base_price_without_vat: number;
    credit_notes_total_net_price_without_vat: number;
    cancellation_reason: string;
    tip: number;
    driver_rating: string;
    dropoff_date: number;
    cancellation_date: number;
    pickup_location: Location;
    planned_dropoff_location: null | Location;
    rejections: Rejection[];
    company: Partial<Company>;
    rider: Partial<Rider>;
    driver: Partial<Driver>;
    bills: Bill[];
    grouped_bills: Bill[];
    trip_connection: TripConnection;
    meeting_point: MeetingPoint;
    operator_logs: OperatorLog[];
}

export interface LightLocation {
    lat: number;
    lng: number;
}
export interface RecalculRefundFormData {
    start_location?: LightLocation;
    end_location?: LightLocation;
    ride_infos?: {
        ride_distance?: number;
        ride_time?: number;
    };
}
export interface RecalculRefoundData {
    pre_tax_customer: number;
    with_tax_customer: number;
    pre_tax_partner: number;
    with_tax_partner: number;
    products: any;
    price_explain: any;
}

export interface ReservationDispatchGroup {
    id: string;
    name: string;
    displayOrder: number;
    selectableByRider: boolean;
    visibleByDriver: boolean;
}

export interface AvailableDispatchGroup {
    default_vehicle_type: AvailableVehicleType;
    id: string;
    name: string;
    reservable: boolean;
    type: string;
    vehicle_types: AvailableVehicleType[];
}

export interface AvailableVehicleType {
    id: string;
    name: string;
    type: string;
}

export interface Industry {
    id: string; // ou uuid
    name: string;
}

export interface Reservation {
    id: number;
    uuid: string;
    number: string;
    creation_date: number;
    planned_pickup_date: number;
    planned_start_date: number;
    planned_start_location: Location;
    planned_end_location: Location;
    cancellation_date: number;
    cancellation_reason: string;
    company: Partial<Company>;
    status: ReservationStatus;
    rider: Partial<Rider>;
    booker: Partial<Rider>;
    order: Order;
    bookings: Booking[];
    active_booking: Booking;
    source: string;
    pro: boolean;
    onboard_payment: boolean;
    nameboard_option: boolean;
    driver_additional_info: string;
    promotion_usage: null | any; //TODO
    dispatch_group: ReservationDispatchGroup;
    subcontract?: SubContract;
    history: History[];
    /** Pre-merged timeline (legacy history + ecs-action-log dispatch events) from privapi. */
    action_logs?: CombinedLog[];
    trip_connection: TripConnection;
    meeting_point: MeetingPoint;
    reason: string;
    reference?: string;
    cost_center: CostCenter;
    book_for_others: boolean;
    favored_driver: Partial<Driver>;
    operator_logs: OperatorLog[];
    provision?: Provision;
}

export interface Provision {
    id: number;
    duration: number;
}

export interface OperatorLogSender {
    id: number;
    email: string;
    firstname: string;
    fullname: string;
    lastname: string;
}
export interface OperatorLog {
    date: number;
    // | {
    //       timestamp: number;
    //       offset: number;
    //   };
    id: number;
    sender: OperatorLogSender;
    text: string;
    resa_id?: number;
    booking_id?: number;
}

export interface TripConnection {
    id: number;
    carrier_IATA_code?: string;
    flight_number?: number;
    arrival_terminal?: string;
    train_number?: string;
    planned_UTC_arrival_date: number;
}

export interface MeetingPoint {
    id: number;
    name: LocalizedString;
    poi: {
        id: number;
        menuname: LocalizedString;
    };
    rdv?: LocalizedString;
    rdv_with_nameboard?: LocalizedString;
    rdv_without_nameboard?: LocalizedString;
}

export enum ReservationStatus {
    CREATED = 'created',
    CANCELLED_NO_CHARGE = 'cancelled_no_charge',
    CANCELLED_CHARGE = 'cancelled_charge',
    ALLOCATED = 'booking_done',
    SUBCONTRACT_PENDING = 'pending',
    SUBCONTRACT_UPDATING = 'updating',
}

export interface ManagementFee extends Extra {
    company_to_extra_id: string;
}

export interface Extra {
    id: string;
    created_at: string;
    updated_at: string;
    name: string;
    type_id: string;
    percent: number;
    amount: number;
    driver_com_add?: number;
    driver_com?: number;
    driver_amount?: number;
    is_global: number;
    history: History[];
}

export interface ExtraType {
    application_order: number;
    applies_to: string;
    created_at: string;
    id: string;
    is_always_applied: boolean;
    is_monthly: boolean;
    name: string;
    updated_at: string;
    vat_rate: number;
}

export interface Service {
    id: string;
    name: string;
    created_at: string;
    default_pricing_set_id: string;
    stop_price: number;
    updated_at: string;
}

export interface PriceDetail {
    type: string;
    value: number;
    vat_rate: number;
    driver_value?: number;
    info?: {
        distance: number;
        km_price: number;
    };
}
/** A zone as the pricing engine echoes it back in the explain payload. */
export interface PriceExplainArea {
    id: string;
    name: string;
    priority: number;
}

/** A pricing set of the inheritance chain walked to price the ride. */
export interface PriceExplainPricingSet {
    id: string;
    name: string;
    parent_id: Nstring;
    service_id: Nstring;
}

/** A tariff of the explain payload: areas and set are given as ids only. */
export interface PriceExplainTariff {
    id: string;
    type: string;
    pricing_set_id: string;
    start_area_id: Nstring;
    end_area_id: Nstring;
}

/**
 * One resolved pricing parameter: which tariff it was read from, or `default`
 * when no tariff of the chain defined it (tariff_id is then null).
 *
 * Rate tables (min_price.*, flat_price, price_per_hour) are leaves of the
 * flattening done by the engine, so an array can reach `value` as well.
 */
export interface PriceExplainField {
    field: string;
    value: number | string | boolean | null | unknown[];
    tariff_id: Nstring;
    /** `unresolved` when no tariff of the chain nor the defaults claimed the field. */
    origin: 'tariff' | 'default' | 'unresolved';
}

/**
 * The leg of the itinerary a resolution priced. Null on the direct
 * start -> end journey; set on each leg of a ride with intermediate stops,
 * which resolves the same horokilometric scope over its own zones.
 */
export interface PriceExplainLeg {
    /** 0 based: the first leg of the itinerary is index 0. */
    index: number;
    start_area_id: Nstring;
    end_area_id: Nstring;
}

/**
 * One findPricingParams() resolution: the parameters read off one tariff stack
 * for one scope. The same scope appears several times in `params` -- once per
 * stop leg, and once per branch when two were priced -- so an entry is only
 * identified by its position in the list.
 */
export interface PriceExplainScope {
    scope: string;
    /** The leg this resolution priced, null for the direct journey. */
    leg: PriceExplainLeg | null;
    /**
     * True when the engine priced two competing branches (the direct journey
     * against the sum of the stop legs) and kept the other one: this
     * resolution was consulted but did not contribute to the returned price.
     */
    discarded: boolean;
    /** The stack that was consulted, highest priority first, by id. */
    tariff_ids: string[];
    fields: PriceExplainField[];
}

/**
 * Why a computed price is what it is: inputs, tariff chain and resolved params.
 * Nullability mirrors the producer: every input the request left out comes back
 * as null.
 */
export interface PriceExplain {
    request: {
        date: Nstring;
        start_location: { lat: number; lng: number };
        end_location: { lat: number; lng: number } | null;
        start_areas: PriceExplainArea[] | null;
        end_areas: PriceExplainArea[] | null;
        journey_estimate: { distance: number; time: number; provider?: string } | null;
        service: { id: string; name: string } | null;
    };
    pricing_sets: PriceExplainPricingSet[] | null;
    /**
     * Every tariff cited by `params`, keyed by id -- held once here rather than
     * repeated in each entry, since the same stack is re-consulted for every
     * scope and every leg. `{}` when none was cited, never null.
     */
    tariffs: { [id: string]: PriceExplainTariff };
    /**
     * The tariffs selected for the base price, highest priority first. Null
     * when the caller priced from an original price, no base tariff being
     * looked up in that case.
     */
    base_tariff_ids: string[] | null;
    /**
     * False when pricing aborted before every component had been resolved:
     * `params` is then a prefix of the walk, not the whole of it.
     */
    complete: boolean;
    /** Why the walk stopped early; null when `complete`. */
    incomplete_reason: Nstring;
    params: PriceExplainScope[];
}

export interface ComputedPrice {
    /**
     * Null when the engine could not price the request. `/price/calculate`
     * answers 422 in that case, but `/price/calculate_and_explain` answers 200
     * with a null price and an `explain` saying why -- that reason being the
     * whole point of the explaining endpoint.
     */
    price: number | null;
    details: PriceDetail[];
    request_id: string;
    /** Set on an unpriced answer, e.g. `NO_PRICING_FOR_AREA`. */
    status?: string;
    explain?: PriceExplain;
}

export interface PricingSet {
    id: string;
    name: string;
    parent_id: Nstring;
    created_at: string;
    updated_at: string;
    company_to_pricing_set_id: string;
    start_date: string;
    end_date: Nstring;
    priority: number;
    service: Partial<Service>;
}

/**
 * A sheet attached to a group, as /groups/:uuid/pricingSets returns it.
 *
 * Same shape as PricingSet with the link id renamed: a group link lives in
 * group_to_pricing_set, so it cannot carry a company_to_pricing_set_id.
 */
export interface GroupPricingSet extends Omit<PricingSet, 'company_to_pricing_set_id'> {
    group_to_pricing_set_id: string;
}

export interface PricingCompany {
    company_to_pricing_set_id: string;
    created_at: string;
    end_date: string;
    id: string;
    infos: LightStructure;
    priority: number;
    start_date: string;
    updated_at: string;
}

export interface CompanyToPricingSet {
    company: LightStructure;
    company_id: string;
    created_at: string;
    end_date: null;
    id: string;
    pricing_set_id: string;
    priority: number;
    start_date: string;
    updated_at: string;
}

export interface Set {
    companies: PricingCompany[];
    created_at: string;
    id: string;
    name: string;
    parent?: Set;
    parent_id: string;
    service: Service;
    service_id: string;
    updated_at: string;
    history: History[];
}

export interface Tariff {
    created_at: string;
    end_area: LightStructure;
    id: string;
    pricing_params: any;
    pricing_set: LightStructure;
    pricing_set_id: string;
    start_area: LightStructure;
    type: string;
    updated_at: string;
    history: History[];
}

export interface Price {
    id: string;
    name: string;
    parent_id: string;
    service_id: string;
    created_at: string;
    updated_at: string;
}

export interface PriceConfirmation {
    currency: string;
    expiry_date: number;
    formatted_price: string;
    formatted_public_price?: string;
    formatted_total_price: string;
    id: string;
    price: number;
    server_timestamp: number;
    service_class?: string;
    total_price: number;
    surge_coeff: number;
    distance: number;
    time: number; // en seconde
}

export interface DispatchGroupAuthorization {
    id: string;
    dispatch_group: string;
    status: boolean;
    status_bo: boolean;
}

export interface CostCenter {
    id: number;
    name: string;
    description: string;
    active: boolean;
}

export interface BanDriver {
    id: number;
    reason: Nstring;
    driver: {
        id: number;
        firstname: string;
        lastname: string;
        class: string;
    };
    company: {
        id: number;
        name: string;
        type: string;
    };
}

export enum CompanyCentralizedPayment {
    central = 'central',
    individual = 'individual',
}

export enum CompanyCentralizedPaymentMode {
    mensual = 'mensual',
    unitary = 'unitary',
}
export enum CompanyMensualCentralizedPaymentMode {
    wire_transfer = 'wire_transfer',
    sepa = 'sepa',
    airplus = 'airplus',
}

export interface AccountManager {
    uuid: string;
    lastname: string;
    firstname: string;
}

export interface GroupNew {
    group: {
        id: string;
        name: string;
        created_at: string;
    };
    company: {
        id: string;
        name: string;
    };
    group_policies?: any; // added from redux
}

export interface CompanyNew {
    id_contract: string;
    name: string;
    created_at: number;
    signed_at: number;
    id_plan: string;
    siren: string;
    account_manager: AccountManager;
    industry: Industry;
    plan_name: string;
    type: 'CORPORATE' | string; // Adjust based on the possible values
    n_user: number;
    company_group?: string;
    // added by front
    group_policies?: GroupPolicy;
    payment_settings?: PaymentSettings;
}

export interface PaymentSettings {
    group_payment_policies: GroupPaymentPolicy[];
    contract_payment_policies: {
        allowed_frequencies: string[];
        allowed_modes: string[];
        allowed_payment_methods: string[];
        cost_centers: {
            allowed: boolean;
        };
    };
    payment_methods: any[];
}

export interface Sepa {
    holder_id: string;
    name: string;
    iban: string;
    rum: string;
    signature_date?: string;
}

export interface Airplus {
    holder_id: string;
    card_number: number;
    expiry_date: string;
}

export interface GroupPaymentPolicy {
    group_id: string;
    user_id?: string | null;
    group_name?: string;
    payment_mode?: string;
    payment_frequency?: string;
    default_payment_method?: { id: string } | any | null;
}

export interface Company {
    id: number;
    uuid: string;
    name: string;
    corporate_name: null;
    book_for_others: boolean;
    creation_date: number;
    deletion_date: number;
    activation_date: number;
    nb_bookings: number;
    centralized_payment: CompanyCentralizedPayment;
    centralized_payment_mode?: CompanyCentralizedPaymentMode;
    centralized_mensual_payment_mode?: CompanyMensualCentralizedPaymentMode | string;
    centralized_mensual_payment_mode_cb_mask?: string;
    management_fee: ManagementFee[];
    extras_list: Extra[];
    pricing_sets: PricingSet[];
    // Only sent for a departement. null with _failed false is the normal case:
    // this group has no sheet of its own and inherits everything from pricing_sets.
    group_pricing_sets?: GroupPricingSet[] | null;
    group_pricing_sets_failed?: boolean;
    grouped_payment_allowed: boolean;
    total_net_price_without_vat_generated_recently: number;
    total_net_price_without_vat: number;
    account_manager: any;
    industry: Industry;
    default_booking_address: null | Address;
    billing_address: null | Address;
    billing_emails: null | string;
    nb_users: number;
    contract_number: string;
    reservation_sms: boolean;
    /** Effective `subcontract_hide_rider` (a department inherits its parent's). */
    subcontract_hide_rider: boolean;
    siren: string;
    vat_number: string;
    purchase_order: string;
    card_alias: string;
    billing_month_payments: any[];
    default_billing_month_payments: any;
    documents: DocumentsID;
    dispatch_group_authorizations: DispatchGroupAuthorization[];
    accountants: Partial<Rider>[];
    cost_centers: CostCenter[];
    default_cost_center: CostCenter;
    type: string;
    departments: Partial<LightDepartment>[];
    history: History[];
    banDrivers: BanDriver[];
    // wtf is that API key appear and disapear
    parent?: LightStructure;
    cost_center_mandatory: boolean;
    ride_reason_mandatory: boolean;
    analytics_reference_enabled: boolean;
    obp_webapp: boolean;
    recipient_type?: string;
    send_bill_export: boolean;
    fid_programs?: Program[];
    travel_policies?: TravelPolicy;
    group_policies?: GroupPolicy;
}

export interface LightDepartment extends LightStructure {
    deletion_date: number;
}
export interface LightCompany extends LightStructure {
    book_for_others: boolean;
    centralized_payment: boolean;
}

export interface CompanyMembership {
    status: CompanyMembershipStatus;
    admin: boolean;
    company: LightCompany;
    department: null | LightCompany;
    centralized_payment: boolean;
    onboard_payment: boolean;
    vip: boolean;
}

enum CompanyMembershipStatus {
    PENDING = 'pending',
    CONFIRMED = 'ok',
    ENDED = 'ended',
    REJECTED = 'rejected',
}

export interface Manager extends User {
    banned: boolean;
    fullname?: string;
    lang: string;
    phone_number: string;
    photo_url: string;
    partner: Partial<Partner>;
}

export enum BanReason {
    BANNED_NEW_USER = 'new_user',
    BANNED_CONFORMITY = 'conformity',
}

export interface ActiveConnection {
    created_at: number; // timestamp
    expire_at: number; // timestamp
    source: string;
}

export interface Group {
    uuid: string;
    name: string;
    role: string[];
}

export interface Membership {
    name: string; // contract name
    uuid: string; // contract uuid
    group: Group;
}

export interface RiderNew {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    language: string;
    company: {
        name: string;
        uuid: string;
        group: Group;
    };
    /**
     * LT-876 - every (contract, group) membership. `company` keeps its singular
     * shape (the most recently granted one) and stays the fallback for an `id`
     * that does not send this yet.
     */
    companies?: Membership[];
    invity: {
        name: string;
        uuid: string;
        group: Group;
    }[];
    active_connections: ActiveConnection[];
    core_id: string;
    fraud_score: number;
    subscription_date: number;
    nb_bookings: number;
    nb_reservations: number;
    vip: boolean;
    booking_suspended?: boolean;
}

export interface RiderAverage {
    value: number | null; // null when the rider has nothing to average yet
    count: number; // number of rides or ratings the average is based on
}

export interface RiderAverages {
    rating_given: RiderAverage; // note the rider gave to drivers
    spending_perso: RiderAverage;
    spending_pro: RiderAverage;
}

export interface Rider extends User {
    uuid: string;
    fullname: string;
    phone_number: string;
    photo_url: string;
    company_memberships: CompanyMembership[];
    default_booking_address: null | Address;
    promotions: Promotion[];
    banned: boolean;
    ban_reason: BanReason;
    ban_description: string;
    banned_until_date: number;
    booking_suspended: boolean;
    credit_perso: number;
    credit_pro: number;
    lang: string;
    subscription_date: number;
    nb_bookings: number;
    nb_reservations: number;
    fraud_score: number;
    anonymized: number;
    averages?: RiderAverages;
    grants: [
        {
            creation_date: number;
            expiration_date: number;
            consumer: {
                description: string;
            };
        },
    ];
    credit_logs: CreditLogs[];
    total_net_price_without_vat_generated_recently: number;
    total_net_price_without_vat: number;
    active_company_membership: CompanyMembership;
    bookings_recent: [];
    history: History[];
}

export interface RiderReserver extends User {
    phone_number: string;
    cb?: string;
    isModeCB: boolean;
    company?: Partial<Company>;
    banned: {
        value: boolean;
        description: string;
        until?: number;
    };
}

export interface RiderFavorites {
    favorites: {
        id: number;
        location: {
            address?: { city: string; name: string; postal_code: string; country: string };
            position: LightLocation;
            id: number;
        };
        name: string;
        type: string;
    }[];
    recent: {
        id: number;
        address?: { city: string; name: string; postal_code: string; country: string };
        position: LightLocation;
    }[];
}

export enum AccountType {
    PRO = 'pro',
    PERSO = 'perso',
}

export interface CreditLogs {
    id: string;
    account_type: AccountType;
    admin: {
        firstname: string;
        lastname: string;
    };
    date: number;
    amount: number;
    text: string;
}

export interface Promotion {
    promotion: {
        description: string;
        code: string;
        name: string;
        use_limit: number;
        expiration_date: number | null;
        creation_date: number | null;
        use_date: number | null;
    };
    is_active: boolean;
}

export interface Vehicle {
    id: number;
    model: string;
    registration_number: string;
    color: string;
    creation_date: number;
    deletion_date: string | number;
    /** One of the Vehicle::DELETED_* reasons: new_vehicle | suspended | removed | invalid_doc | too_old. */
    deletion_reason: string | null;
    insurance_attachment: string;
    green_card_attachment: string;
    grey_card_attachment: string;
    immatriculation_date: number;
    insurance_validity_date: number;
    partner: Partial<Partner>;
    dispatch_groups: DispatchGroup[];
    vehicle_model: VehicleModel;
    vehicle_color: VehicleColor;
    vehicle_motorization: VehicleMotorization;
    documents: DocumentsID;
    history: History[];
}

export interface VehicleEditPayload {
    color?: string;
    model?: string;
    registration_number?: string;
    dispatch_groups?: DispatchGroup[];
    enable?: boolean;
}

export interface LocalizedString {
    fr: string;
    en: string;
}

export interface VehicleBrand {
    name: string;
}

export interface VehicleModel {
    id: number;
    name: string;
    brand: VehicleBrand;
    type: VehicleTypeLocalized;
}

export interface VehicleColor {
    id: number;
    name: string;
}

export interface VehicleMotorization {
    id: number;
    localized_string: LocalizedString;
}

export interface VehicleTypeLocalized {
    localized_name: LocalizedString;
    name?: string;
}

export interface LightStructure {
    id: string;
    name: string;
    uuid?: string;
}

export interface VehicleType {
    id: number;
    brand: VehicleBrand;
    localized_string: LocalizedString;
    type: VehicleTypeLocalized;
    max_age: number;
    dispatch_groups: VehicleDispatchGroup[];
}

export interface PayloadCreationVehicleType {
    brand: string;
    model: string;
    age_max: number;
    isVan: boolean;
    isBerline: boolean;
    age_inf_berline: number;
}

export interface VehicleTypeDetails {
    id: string;
    localized_name: LocalizedString;
}

export interface VehicleDispatchGroup {
    dispatch_group: DispatchGroup;
    max_eligibility_age: number;
}

export interface PrebookPlanning {
    id?: string;
    time_slots: {
        hours: {
            maxPrebookPerDriver: number;
            rideDate: {
                end: string;
                start: string; //"09:00"
            };
            visibility: {
                delay: number;
                duration: number;
            };
        }[];
        weekDays: number[]; // days number [1,2]
    };
}
export interface PrebookGroupCreationPayload {
    min_prebook_interval: number;
    name: string;
    suspension_duration: number;
    plannings?: PrebookPlanning[];
}

export interface PrebookGroup {
    id: string;
    min_prebook_interval: number;
    name: string;
    suspension_duration: number;
    creation_date: number;
    plannings?: PrebookPlanning[];
}
export interface DriverDetails {
    id: number;
    currentBookingCount: number;
    lastRideDate: number;
    activationDate: number;
    prebookGroup: PrebookGroup;
    prebookGroupEntryDate: number;
    prebookSuspendedUntilDate: number;
    controlTower: LightStructure;
}
export interface Driver extends User {
    uuid: string;
    fullname: string;
    phone_number: string;
    subscription_date: number; // timestamp, creation date of the account
    licence_number_atout_france: string;
    licence_number_driea: string;
    photo_url: string;
    banned: boolean;
    ban_reason: string;
    ban_description: string;
    banned_until_date: string;
    nb_bookings_week_b2c: number;
    nb_bookings_week_b2b: number;
    nb_bookings_month_b2c: number;
    nb_bookings_month_b2b: number;
    total_net_price_without_vat_week_b2c: number;
    total_net_price_without_vat_week_b2b: number;
    total_net_price_without_vat_month_b2c: number;
    total_net_price_without_vat_month_b2b: number;
    rating: number;
    tpe: string;
    details: DriverDetails;
    do_enabled: string;
    lang: string;
    driving_licence_number: string;
    driving_licence_attachment: string;
    vtc_card_attachment: string;
    hiring_certificate_attachment: string;
    police_record_attachment: string;
    adp_attachment: string;
    partner: LightPartner;
    dispatch_groups: DispatchGroup[];
    active_payment_rule_association: null | PaymentRuleAssociation;
    non_expired_payment_rule_associations: PaymentRuleAssociation[];
    name_dispatch_groups: any[]; //TODO: check or delete ?
    documents: Documents;
    nb_bookings: number;
    history: History[];
    last_session?: LastSession;
}

/** One gamification movement: points gained (amount > 0) or spent (amount < 0). */
export interface DriverPointOperation {
    uuid: string;
    amount: number;
    event: string;
    label: string | null;
    created_at: number; // timestamp
    entity_type: string | null; // 'booking' | 'reservation'
    entity_uuid: string | null;
    entity_id: number | null; // BO id of the ride, null when it no longer exists
}

export interface DriverPoints {
    total: number; // current balance
    gained: number; // lifetime sum of the positive operations
    spent: number; // lifetime sum of the negative ones, as a positive number
    nb_operations: number;
    page: number;
    num_per_page: number;
    operations: DriverPointOperation[];
}

export interface LastSession {
    sign_in: number;
    sign_out: number;
    app_version: string;
    device?: {
        type: string;
        model_name: string;
        os_version: string;
    };
}

export interface LightPartner {
    id: number;
    name: string;
    uuid: string;
    licence_number_atout_france: string;
    licence_number_driea: string;
}

export interface DispatchGroup {
    id: string;
    name: string;
    defaultAvailable: boolean;
    displayOrder: number;
    selectableByRider: boolean;
    visibleByDriver: boolean;
}

export interface PaymentRuleAssociation {
    id: number;
    start_date: number;
    end_date: string;
    rule: {
        id: number;
        creation_date: number;
        last_update: number;
        description: string;
        type: string;
        duration?: number;
        sub_rules?: Rule[];
        default_rule?: Rule;
        levels?: Level[];
    };
}

export interface Function {
    y_origin: number;
    slope: number;
}

export interface Rule {
    id: string;
    creation_date: number;
    last_update: number;
    description: string;
    type: string;
    hourly_rate?: number;
    normal_function?: Function;
    reservation_fee_function?: Function;
    cancelled_booking_function?: Function;
}

export interface Criteria {
    requirement: number;
    criterion: string;
}

export interface Level {
    criteria: Criteria[];
    rule: Rule;
    rank: number;
}

export interface BillingPeriod {
    months: number;
    weeks: number;
    days: number;
}

export interface BillingStep {
    step: 'create_month_bills' | 'create_month_bills_docs' | 'send_month_bills' | 'pay_month_bills' | 'finished';
    status: 'unlaunched' | 'pending' | 'done';
    task_id: string;
}

export interface Address {
    id: number;
    street: string;
    city: string;
    postal_code: string;
    country: string;
    formatted_address?: string;
    name?: string;
}

export interface Region {
    id: number;
    name: string;
}

export interface ActiveBillableProducts {}
export interface Partner {
    id: number;
    uuid: string;
    name: string;
    banned: boolean;
    creation_date: number;
    billing_period: BillingPeriod;
    bank_iban: string;
    bank_bic: string;
    siret: string;
    siret_attachment: string;
    insurance_pro_attachment: string;
    licence_number_driea: string;
    licence_number_driea_attachment: string;
    licence_number_atout_france: string;
    licence_number_atout_france_attachment: string;
    rib_attachment: string;
    company_type: string;
    share_capital: string;
    rcs: string;
    active_billable_products: ActiveBillableProducts[];
    vat_number: string;
    active_payment_rule_association: null | PaymentRuleAssociation;
    non_expired_payment_rule_associations: PaymentRuleAssociation[];
    billing_address: Address;
    region: Region;
    express_payment_status: string;
    additional_info: string;
    documents: DocumentsID;
    history: History[];
    current_period: PartnerCurrentPeriod;
}

export interface PartnerCurrentPeriod {
    adjustments: RegulationBilling[];
    rides: Ride[];
}

export interface Ride {
    billing_status: string;
    booker: LightStructure;
    booking_reason: string;
    company_id: string;
    cost_center_id: string;
    cost_center_name: string;
    created_at: string;
    customer_bill_id: string;
    customer_id: string;
    customer_name: string;
    distance: number;
    driver: LightStructure;
    driver_surge: number;
    end_address: Partial<Address>;
    end_date: string;
    id: string;
    issue_date: string;
    original_price: number;
    partner_bill_id: string;
    partner_id: string;
    payment_method_id: string;
    payment_mode: string;
    pre_tax_customer: number;
    pre_tax_partner: number;
    ride_date: string;
    ride_id: number;
    ride_number: string;
    ride_status: string;
    rider: LightStructure;
    rider_surge: number;
    start_address: Partial<Address>;
    start_date: string;
    user_id: string;
    with_tax_customer: number;
    with_tax_partner: number;
}

export interface Documents {
    driver_license?: Document;
    driver_license_statement?: Document;
    kbis?: Document;
    rib?: Document;
    rc_pro?: Document;
    contract?: Document;
    insurance?: Document;
    green_card?: Document;
    grey_card?: Document;
    technical_control?: Document;
    vtc_license?: Document;
    vtc_card?: Document;
    adp?: Document;
    rm?: Document;
    urssaf_attestation?: Document;
    hiring_certificate?: Document;
    police_record?: Document;
}

export interface DocumentsID {
    driver_license?: number;
    driver_license_statement?: number;
    kbis?: number;
    rib?: number;
    rc_pro?: number;
    contract?: number;
    current_version?: {
        user_id?: number;
    };
    insurance?: number;
    green_card?: number;
    grey_card?: number;
    technical_control?: number;
    vtc_license?: number;
    vtc_card?: number;
    adp?: number;
    rm?: number;
    urssaf_attestation?: number;
    hiring_certificate?: number;
    police_record?: number;
}

export interface LightDocument {
    id: number;
    type: string;
    current_version: {
        start_date: number;
        end_date: null | number;
    };
}

export interface Document {
    id: number | string;
    creation_date: number;
    current_version: null | {
        id: number;
        upload_at: number;
        state: string;
        user_id: number;
        procedure_id?: number;
        signatories?: any; // maybe an object with many other keys IDK :o|
    };
    document_type: string;
    document_class: string;
    driver_id?: number;
    partner_id?: number;
    signature_required?: boolean;
}

export interface Author {
    id: number;
    firstname: string;
    lastname: string;
    class: string;
}

export interface HistoryData {
    // privapi sends null when the action has no before/after value (e.g. a plain insert).
    oldValue: string | null;
    newValue: string | null;
    pid: number;
}

export interface History {
    pk: number;
    entity: string;
    id: number;
    action: string;
    actionDate: number;
    author: Author;
    description: string;
    history?: HistoryData;
}

export interface ActionLogEntryAuthor {
    id?: string | number;
    type?: string; // "admin" | "operator" | "driver" | "rider" | "user" | "booker"
    class?: string; // legacy/core-style role field (alternative to `type`)
    lastname?: string;
    firstname?: string;
}

/** Dispatch lifecycle event fetched from ecs-action-log via the privapi `/actionlog/*` proxy. */
export interface ActionLogEntry {
    id: string;
    event_name: string;
    ride_id: string;
    process_id: string | null;
    workflow_name: string | null;
    source: string;
    message_id: string | null;
    payload: any;
    treated: boolean | null;
    treated_at: string | null;
    created_at: string; // ISO
    author?: ActionLogEntryAuthor | null;
}

/** A ride timeline row: either legacy core history or an ecs-action-log dispatch event. */
export type CombinedLog = History | ActionLogEntry;

export enum WAITING_LINE_STATUS {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    CLOSED = 'closed',
}

export enum WAITING_LINE_CATEGORY {
    AIRPORT = 'airport',
    TRAIN_STATION = 'train_station',
    EVENT = 'event',
}

export type HourRange = {
    start: string;
    end: string;
};

export type TimeSlots = {
    [id in 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun']?: HourRange[];
};

export interface DispatchGroupQueue {
    id: string;
    name: string;
    capacity: number;
    load: number;
    status: string;
}

export interface DispatchGroupInput {
    dispatch_group_id: string;
}

export interface Rank {
    id: string;
    name: string;
    category: WAITING_LINE_CATEGORY;
    area_id: string;
    capacity: number;
    has_stop_override: boolean;
    opening_hours?: TimeSlots;
    status?: WAITING_LINE_STATUS;
    dg?: DispatchGroupQueue[];
    start_datetime: string;
    end_datetime: string;
}

export interface CreateRankDTO {
    name: string;
    area: {
        polygon: Array<Coords>;
    };
    dispatch_groups: DispatchGroupInput[];
    start_datetime: string;
    end_datetime?: string;
}

export interface Promo {
    rider_eligibility: any[];
    until_date_optin: string;
    booking_eligibility: any[];
    until_date: string;
    is_pro: boolean;
    type: string;
}

// module Bill
export interface ProductTypeExceptional {
    id: string;
    created_at: string;
    updated_at: string;
    name: string;
    label: string;
    vat_type_id: string;
    is_exceptional: number;
    vat_rate: number;
}

export interface Product {
    type: string;
    amount: number;
}

export interface RectificationAddPayload {
    products: Product[];
    additional_pages?: any;
}

export interface SaveExceptionalPayload {
    amount_pre_tax: number;
    amount_with_tax: number;
    customer: {
        user_id: string;
        company_id?: string;
    };
    label?: string;
    product_type: string;
}

export enum RideStatus {
    ACCEPTED = 'accepted',
    DISPATCH_TIMEOUT = 'dispatch_timeout',
    ALLOCATED = 'allocated',
    PROCESSING = 'processing',
    SEEN = 'seen',
    RECEIVED = 'received',
    ON_WAY = 'on_way',
    PASSENGER_ON_BOARD = 'passenger_on_board',
    AT_PICKUP = 'at_pickup',
    FINISHED = 'finished',
    CANCELLED = 'cancelled',
    CANCELLATION_NO_CHARGE = 'cancellation_no_charge',
    CANCELLATION_WITH_CHARGE = 'cancellation_with_charge',
}

export enum BookingStatus {
    CREATED = 'created',
    ACCEPTED = 'accepted',
    DRIVER_ARRIVED = 'driver_waiting',
    RIDE_STARTED = 'ride_started',
    RIDE_ENDED = 'ride_ended',
    CLOSED = 'closed',
    CANCELLED = 'cancelled',
    FIXEDRATE_RIDE = 'fixed_rate',
    METERED_RIDE = 'metered',
}

export enum BookingCancelReason {
    NO_DRIVER_AVAILABLE = 'no_driver_available',
    NO_SERVICE = 'no_service',
    RIDER_CANCELLATION_NO_CHARGE = 'rider_cancellation_no_charge',
    RIDER_CANCELLATION_CHARGE = 'rider_cancellation_charge',
    SYSTEM_CANCELLATION_NO_CHARGE = 'system_cancellation_no_charge',
    SYSTEM_CANCELLATION_CHARGE = 'system_cancellation_charge',
    DRIVER_CANCELLATION = 'driver_cancellation',
    DRIVER_CANCELLATION_CHARGE = 'driver_cancellation_charge',
    OPERATOR_CANCELLATION_CHARGE = 'scom_cancellation_charge',
    OPERATOR_CANCELLATION = 'scom_cancellation',
    RESERVATION_CANCELLED = 'reservation_cancelled',
    OTHER = 'other',
}

export interface CancelReason {
    id: string;
    label?: string;
    status?: string;
    creation_date?: number;
}

export interface BookingDetail {
    id: number;
    distance: number;
    cancel_description: string;
    source: any; //idk
    action: any; //idk
    surge_coeff: number;
    public_surge_coeff: number;
    driver_surge_coeff: number;
}

export interface BookingOrder {
    id: number;
    base_price_with_vat: number;
    base_price_without_vat: number;
}

export interface BookingRejection {
    type: string;
    date: Date | string;
}

export interface SubContract {
    id: number;
    lecab_id?: string;
    lecab_number?: string;
    uber_id?: string;
}

interface Points extends Coords {
    date: Date | string;
    speed: number;
}

export interface BookingCancelPayload {
    description?: string;
}

export interface Distance {
    date: number;
    distance: number;
    time: number;
}

// Ride

interface RideAddress {
    type: string;
    location: {
        lat: number;
        lng: number;
        address: {
            full_name: string;
            name: string;
            country: string;
            postal_code: string;
            city: string;
        };
        control_tower: number | null;
    };
    meeting_points?: RideMeetingPoint[];
    meeting_points_nameBoard?: RideMeetingPoint[];
    details: {
        street: string;
        street_number: string;
        city: string;
        country: string;
        zip_code: number;
        full_name: string;
    };
}

interface RideMeetingPoint {
    id: number;
    location: LightLocation;
    name: string;
    rdv_point: string;
    type: string;
}

interface RideContact {
    phone: string;
    primary: number;
    pro: number;
    validated_at: string;
}

interface RideBooker {
    id: string;
    firstname: string;
    lastname: string;
    phones: RideContact[];
    emails: RideContact[];
    created_at: string;
    roles: string[];
}

interface RideRider {
    id: string;
    firstname: string;
    lastname: string;
    phone_number: string;
    email: string;
}

interface RideDisplay {
    display_name: string;
    display_order: number;
    disabled: boolean;
    default_selection: boolean;
    ref_message: string;
}

interface RideCarrySettings {
    max_passenger: number;
    max_small_luggage: number;
    max_large_luggage: number;
}

interface RideService {
    type: string;
    id: string;
    uuid: string;
    name: string;
    description: string;
    status: string;
    display: RideDisplay;
    carry_settings: RideCarrySettings;
}

interface RideActionDetails {
    entity: string;
    id: number;
    status: string;
    cancel_reason: string | null;
    eta: string | null;
}

interface RideActionHistory {
    resulting_status: string;
    date: string;
    triggered_by?: {
        id: string;
        firstname: string;
        lastname: string;
    };
    action_origin: string;
    details?: RideActionDetails;
}

interface RideVehicle {
    color: string;
    enabled: boolean;
    id: string;
    model: string;
    brand: string;
    registration_number: string;
}

interface RideBilling {
    id: string;
    type: string;
    status: string;
}

interface RideEmergency {
    enabled: boolean;
    history: any[]; // Type information not provided in the payload
}

interface RideExtra {
    id: string;
    amount: number;
    description: string;
    type: RideExtraType;
}

export enum RideExtraType {
    TIPS = 'TIPS',
    TOLL = 'TOLL',
}

export interface RideModule {
    _id: string;
    action_logs: Partial<History[]>;
    operator_logs?: OperatorLog[];
    booking_logs?: any[];
    core_booking_details?: any;
    driver_rejections?: Rejection[];
    core_history: {
        uuid_core: string;
        id_core: number;
        core_date: string;
        type: string;
        flag: string;
        cancel_reason?: string;
        cancel_description?: string;
    }[];
    id: string;
    actions_history: RideActionHistory[];
    booker: RideBooker;
    booker_id: string;
    booking_platform: string;
    cost_center?: Pick<CostCenter, 'id' | 'name'>;
    creation_date: number;
    dispatch_engine: string;
    driver_note?: string;
    encoded_route: string;
    group: {
        name: string;
        uuid: string;
        contract: {
            uuid: string;
            name: string;
            plan: {
                type: string;
            };
        };
    };
    is_asap: boolean;
    is_free_ride: boolean;
    nameboard_option: boolean;
    number: string;
    payment_method: {
        id: string;
    };
    payment_policy: {
        payment_frequency: string;
        payment_mode: string;
        default_payment_method_id: string;
        user_id: string | null;
        group_id: string;
    };
    price_details: {
        client_final_price: number;
        base_price: number;
        pricing_request_id: string;
        core_price_confirmation_id: number;
        currency: string;
        promotion: any; // Type information not provided in the payload
        extras: RideExtra[]; // Type information not provided in the payload
    };
    ride_reason?: string;
    riders: RideRider[];
    service: RideService;
    status: RideStatus;
    stops: {
        address: RideAddress;
        stop_type: string;
        stop_order: number;
        meeting_point_id?: number;
        driver_departure_time?: number;
        driver_arrival_time?: number;
    }[];
    subcontracted: boolean;
    updated_at: number;
    emergency: RideEmergency;
    planned_start_date: number;
    cancel_reason: string;
    cancellation_date: number;
    driver_rating: {
        score: number;
        comment: string;
    };
    driver_tracking: {
        driver_id: string;
        location: any[]; // Type information not provided in the payload
    };
    start_date: number;
    driver: {
        id: string;
        firstname: string;
        lastname: string;
        phone_number: string | null;
        status: string;
        note: number;
        partner: {
            id: string;
            name: string;
        };
        picture: string;
    };
    partner: {
        id: string;
        name: string;
    };
    ride_accepted_date: number;
    vehicle: RideVehicle;
    actual_start_date: number;
    ride_ended_date: number;
    billing: RideBilling;
}

// Module booking
export interface BookingModule {
    bills_total_base_price_with_vat: number;
    bills_total_net_price_without_vat: number;
    bills_total_base_price_without_vat: number;
    credit_notes_total_net_price_without_vat: number;

    rejections: Rejection[];
    bills: Bill[];
    grouped_bills: Bill[]; //TODO
    trip_connection: TripConnection;
    meeting_point: MeetingPoint;

    id: string;
    uuid: string;
    number: string;
    creation_date: number;
    reservation: Partial<Reservation>;
    acceptance_date: number;
    driver_arrival_date: number;
    pickup_date: number;
    status: BookingStatus;
    cancellation_reason: string;
    cancellation_description: string;
    cancel_reason_rider?: CancelReason;
    fixed_rate: boolean;
    onboard_payment: boolean;
    surge_coeff: number;
    nameboard_option: boolean;
    driver_additional_info: string;
    time_to_destination: any;
    distance_to_destination: any;
    details: BookingDetail;
    dropoff_date: number;
    tip: number;

    //
    regulations_billing?: RegulationBilling[];
    ride_billing?: any; // idk
    ride_uuid: string; // Ride UUID for Ride Manager
    bill_billing?: any;
    products_billing?: any;
    refunds_billing?: BillPartner[];

    //
    order: BookingOrder;
    cancellation_date: number;
    partner_bill_booking_line: any; //idk
    initial_distance: Distance;
    latest_distance: Distance;
    driver_rating: number;
    rider_feedback: any; //idk
    dispatch_group: ReservationDispatchGroup;
    messages: any[];
    pickup_location: Location;
    dropoff_location: Location;
    planned_dropoff_location: Location;
    company: Partial<Company>;
    rider: Partial<Rider>;
    booker: Partial<Rider>;
    driver: Driver;
    promotion_usage: any; // idk
    regulations: any[]; //idk
    operator_logs: OperatorLog[];
    vehicle: Partial<Vehicle>;
    history: Partial<History[]>;
    /** Pre-merged timeline (legacy history + ecs-action-log dispatch events) from privapi. */
    action_logs?: CombinedLog[];
    subcontract?: SubContract;
    points: Points;
    cost_center?: CostCenter;
    reason?: string;
    reference?: string;
    tolls?: BookingToll[];
    paiement_mode: string;
    driver_ride_com?: number;

    status_description?: string;
    status_popup?: {
        title: string;
        message: string;
    };
}

export interface BookingToll {
    amount: number;
    id: number;
    lat: number;
    lng: number;
    receipt: string;
}

export interface AgentPhone {
    id: number;
    phone_id: string;
    used: number;
}

export interface Agent {
    agent_id: number;
    agent_group_id: number;
    agent_service_id: number;
    agent_phone?: AgentPhone;
}

// VIADIALOG
export interface ConnectFreeSeatingResponse {
    access_token: string;
    expires_in: number;
    refresh_token: string;
    scope: string;
    token_type: string;
}
export interface UserStorage {
    access_token: string;
    expires_at: Date;
    user: User;
    rights: Rights;
}

export interface Rights {
    [id: string]: 'W' | 'R';
}

export enum DocumentMode {
    SMS = 'sms', // old Yousign V1
    YOUSIGN = 'yousign', // Yousign V3
}

export enum DocumentState {
    Created = 'created',
    Signing = 'signing',
    Pending = 'pending',
    Active = 'active',
    Terminated = 'terminated',
}

export enum DocType {
    DriverLicense = 'driver_license',
    DriverLicenseStatement = 'driver_license_statement',
    PoliceRecord = 'police_record',
    Rib = 'rib',
    Kbis = 'kbis',
    RcPro = 'rc_pro',
    GreyCard = 'grey_card',
    GreebCard = 'green_card',
    Insurance = 'insurance',
    VtcLicense = 'vtc_license',
    VtcCard = 'vtc_card',
    Adp = 'adp',
    UrsafAttestation = 'urssaf_attestation',
    HiringCertificate = 'hiring_certificate',
}

export interface DocumentType {
    id: any;
    name: string;
    docType: DocType | string;
    readOnly?: boolean;
    mode?: DocumentMode;
    startDate?: boolean;
    startLabel?: string;
    endDate?: boolean; // Validité
    endDateDisable?: boolean;
    lastControlDate?: boolean; // Vérif physique
    controlDate?: boolean; // Prochaine vérification
    maxDate?: number; // additional year to add to creation date only used for end_date maxDate
}

export interface Area {
    children?: Array<Area>;
    created_at: string;
    id: string;
    name: string;
    parent_id: string;
    polygon: Array<Coords>;
    priority: number;
    updated_at: string;
    start_pricing: Tariff[];
    end_pricing: Tariff[];
    history: History[];
}

interface EtaGroup {
    closest: {
        color: string;
        distance: number;
        driver: Partial<Driver>;
        eta: number;
        id: string;
        model: string;
        position: Partial<Location>;
    };
    id: string;
    status: string;
}

export interface POIStatus {
    POI: POIDetails;
    arrival_terminal: string;
    carrier_name: string;
    flight_number_and_carrier_name: string;
    id: number;
    timezone: string;
    planned_arrival_date: number;
}

interface POIDetails {
    id: number;
    name: string;
    type: string;
    rdv_point: string;
    position: Partial<Location>;
}

export interface POI {
    id: number;
    mode: string;
    name: string;
    menuname: string;
    force_selection: boolean;
    POI: Array<POIDetails>;
    POI_nameboard: Array<POIDetails>;
    area: {
        center: Partial<Location>;
        radius: number;
        type: string;
    };
}

export interface EtaWithGroups {
    status: string;
    data: DataByID<EtaGroup>;
}

export interface RootArea {
    children?: Array<Area>;
}

export interface RootPricing {
    children?: Array<Price>;
}

export interface Issue {
    id: number;
    project: IssueStatus;
    subject: string;
    description: string;
    category: LightObject;
    status: IssueStatus;
    assignee: LightObject;
    author: LightObject;
    priority: IssueStatus;
    created_at: string;
    updated_at: string;
    closed_at: string;
    is_private: boolean;
    entries: Entry[];
    attachments: Attachment[];
    watchers: any[]; //TODO
    meta_data: DataByID<any>;
}

export interface Attachment {
    id: number;
    url: string;
    name: string;
    description: string;
    content_type: string;
}

export interface Entry {
    id: number;
    comment: string;
    created_at: string;
    is_private: boolean;
    updates: DataByID<EntryUpdate> | DataArrayByID<MultipleEntryUpdate>;
    user: LightObject;
}

export interface EntryUpdate {
    before: string;
    after: string;
}
export interface MultipleEntryUpdate {
    before: LightObject;
    after: LightObject;
}
export interface LightObject {
    id: number;
    name: string;
}

export interface IssueStatus {
    key: string;
    name: string;
}
export interface IssueCategory {
    id: number;
    name: string;
    assignee_id: number;
}

export interface Assignee {
    id: number;
    type: string;
    firstname: string;
    lastname: string;
}

export interface KeyName {
    key: string;
    name: string;
}

export interface TicketingFile {
    id: string;
    name: string;
}
export interface TicketingUser {
    email: string;
    firstname: string;
    groups: LightStructure[];
    id: number;
    lastname: string;
    project_roles: { project: KeyName; roles: KeyName[] }[];
    uid: string;
    user_bo: {
        id: number;
        type: 'admin' | 'rider' | 'manager' | 'driver' | string;
        fullname: string;
        partner_id: number;
    };
}

export interface FileUpload {
    file: any;
    id: number;
    src: string;
}

export interface ReservationCallCenter {
    id: number;
    type: 'booking' | 'reservation';
}

export enum BillStatus {
    PENDING = 'pending',
    PAYMENT_PENDING = 'payment_pending',
    PAYMENT_FAIL_SOFT = 'payment_fail_soft',
    PAYMENT_FAIL_HARD = 'payment_fail_hard',
    PAYMENT_MANUAL = 'payment_manual',
    PAID = 'paid',
    CANCELLED = 'cancelled',
}

export enum BillPaymentType {
    ADYEN = 'card_adyen',
    OGONE = 'card_ogone',
    SEPA = 'sepa',
    TRANSFER = 'wire_transfer',
}

// LeCabGeo
export interface LCGAddressDetails {
    address: {
        city: string;
        country: string;
        country_code: string;
        level: string;
        number: string;
        postal_code: string;
        state: string;
        state_code: string;
        street: string;
        text: string;
        vicinity: string;
    };
    categories: string[];
    icon: any;
    location: number[];
    name: string;
    place_id: string;
    rating: any;
}

// ID
export interface IDRole {
    granted_at: string;
    expires_at?: string;
    expired_at?: string;
    name: string;
    rights: IDRight[];
    uuid: string;
}

export interface IDRoleDetail {
    tag: string;
    description: string;
    rights: IDRight[];
    uuid: string;
}

export interface IDRight {
    grant: 'R' | 'W' | string;
    tag: string;
}

export interface IDEmployee {
    id: string;
    firstname: string;
    lastname: string;
    created_at: string;
    emails: {
        email: string;
        primary: boolean;
        pro: boolean;
        validated_at: string;
    }[];
    phones: {
        phone: string;
        primary: boolean;
        pro: boolean;
        validated_at: string;
    }[];
    core: {
        class: string;
        consumer: number;
        created_at: string;
        id: number;
        token: string;
        uuid: string;
    }[];
    roles: IDRole[];
    apps: {
        app: string;
        tag: string;
        type: string;
        url: string;
        uuid: string;
    }[];
}

// FID
export enum FidRewardType {
    COUPON = 'coupon',
    PARTNERSHIP = 'partnership',
    MAIL = 'mail',
}

export enum StrategyType {
    PERCENT = 'percent',
    FIXED = 'fixed',
}

export enum FidType {
    MONTH = 'monthly',
    TARGET = 'target',
}

export interface Program {
    id?: string;
    id_company: string;
    start_date: string;
    end_date?: string;
    updated_at?: string;
    deleted_at?: string;
    name: string;
    type: FidType;
    steps: (CouponStep | PartnershipStep)[];
}

export enum StopType {
    PICKUP = 'PICKUP',
    STOP = 'STOP',
    DROP_OFF = 'DROP_OFF',
}

export interface TravelPolicyTimeSlot {
    id: string;
    start: string;
    end: string;
}

export interface TravelPolicyArea {
    latitude: string;
    longitude: string;
    radius: string;
    stop_type: StopType;
}

export interface TravelPolicy {
    areas: TravelPolicyArea[];
    company: {
        id: string;
    };
    time_slots: {
        [day: string]: TravelPolicyTimeSlot[];
    };
}

export interface GroupPolicy {
    entity_id: string;
    book_for_group_guests: boolean;
    book_for_group_members: boolean;
    cost_center_mandatory: boolean;
    default_settings: DefaultSettings;
    revision: number;
    tip_not_allowed: boolean;
    travel_reason_mandatory: boolean;
    type: 'group';
    updated_at: number;
    default_cost_center_mode: string;
    disabled_dispatch_groups: string[];
    favorites: string[];
    recurring_enable: boolean;
}

export interface DefaultSettings {
    type: 'group-settings';
    default_addresses: {
        pickup: string | null;
        dropoff: string | null;
    };
    default_dispatch_group_id: string;
    default_cost_center_id: string;
}

export interface CouponStep {
    threshold: number;
    mail: string;
    reward_type: FidRewardType;
    strategy: StrategyType;
    value: number;
    validity: number;
}
export interface PartnershipStep {
    threshold: number;
    mail: string;
    reward_type: FidRewardType;
    link: string;
}

export interface Mail {
    threshold: number;
    mail: string;
    reward_type: Mail;
    link: string;
}

export interface Template {
    uuid: string;
    name: string;
    filename: string;
    placeholders: string;
    channel: {
        uuid: string;
        name: string;
    };
}

export interface MarketingPromotion {
    amount: number;
    description: string;
    id: number;
    is_active: boolean;
    name: string;
    nb_riders: number;
    nb_rides: number;
    optin: number;
    optin_limit: string;
    ride_limit: string;
    type: string;
}

export interface MarketingPromotionDetails {
    amount: number;
    description: string;
    id: number;
    code: string;
    use_limit: number;
    optin_limit: string;
    ride_limit: string;
    type: string;
    is_pro: boolean;
    ride_type: string;
    ride_service: string;
    new_user: boolean;
}

export enum SortOrder {
    ASC = 'asc',
    DESC = 'desc',
}

// TOWER
export interface Tower {
    id: string;
    name: string;
    position: LightLocation;
    radius: number;
    lat?: number;
    lng?: number;
}

// DRIVER COMMUNICATION

export enum DRIVER_COMMUNICATION_STATUS {
    UPCOMING = 'upcoming',
    ACTIVE = 'active',
    ENDED = 'ended',
}

export interface DriverCommunicationLocation {
    address: string;
    lat: number;
    lng: number;
}

export interface DriverCommunication {
    id: number;
    title: string;
    description: string;
    location: DriverCommunicationLocation | null;
    start_date: string; // ISO 8601, UTC
    end_date: string; // ISO 8601, UTC
    status: DRIVER_COMMUNICATION_STATUS;
    created_by: number | null;
    creation_date: string;
    update_date: string | null;
}

export interface DriverCommunicationDTO {
    title: string;
    description: string;
    location: DriverCommunicationLocation | null;
    start_date: string;
    end_date: string;
}

// GENERIC

export type DataByID<T> = {
    [id: string]: T;
};

export type DataByIdWithNumber<T> = {
    [id: number]: T;
};

export interface DataArrayByID<T> {
    [id: string]: T[];
}

export interface PricingByID<T> {
    [id: string]: {
        data: T;
    };
}

export type RideById = DataByID<RideModule>;

export type BookingById = DataByID<BookingModule>;

export type ReservationById = DataByID<Reservation>;

export type ManagerById = DataByID<Manager>;
export type ManagerArrayById = DataArrayByID<Manager>;

export type DriverById = DataByID<Driver>;
export type DriverArrayById = DataArrayByID<Driver>;

export type CompanyById = DataByID<Company>;
export type GroupById = DataByID<GroupNew>;

export type DocumentById = DataByIdWithNumber<Document>;

export type PartnerBillById = DataByIdWithNumber<BillPartner>;
export type PartnerById = DataByID<Partner>;

export type VehicleById = DataByID<Vehicle>;
export type VehicleArrayById = DataArrayByID<Vehicle>;
export type VehicleTypeById = DataByID<PayloadCreationVehicleType>;

export type RiderById = DataByID<Rider>;
export type RiderArrayById = DataArrayByID<Rider>;

export type PartnerBillArrayById = DataArrayByID<BillPartner>;

export type AreaByID = DataByID<Area>;

export type SetByID = PricingByID<Set>;
export type TariffArrayByID = DataArrayByID<Tariff>;
export type TariffByID = DataByID<Tariff>;

export type PriceConfirmationById = DataByID<PriceConfirmation>;

export type AssigneeArrayByIssueId = DataArrayByID<Assignee>;

export type PrebookById = DataByID<PrebookGroup>;

export type RoleDetailById = DataByID<IDRoleDetail>;
export type EmployeeById = DataByID<IDEmployee>;

export type PromoById = DataByID<Promo>;
